<template>
    <tr>
        <td colspan="2">
            <div class="responsive-table">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <strong>{{ grupo.Descricao }}</strong>
                            </td>
                            <td width="200"></td>
                        </tr>
                        <tr v-for="despesa in grupo.Itens" :key="despesa.id">
                            <td>{{ despesa.Descricao }}</td>
                            <td align="right" class="text-red">{{ despesa.Valor * -1 | number_format }}</td>
                        </tr>
                        <tr>
                            <td align="right">
                                <strong>Total</strong>
                            </td>
                            <td align="right">
                                <strong class="text-red">{{ grupo.ValorGrupo * -1 | number_format }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </td>
    </tr>
</template>
<script>
export default {
    props: [
        'grupo'
    ],
    filters: {
        number_format(value) {
            return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
        }
    }
}
</script>